import { useField } from 'react-final-form';
import { resolveUseSamePath } from './resolveUseSamePath';
export var TrackFieldValueByName = function (fieldName, fieldToTrack, useSamePath) {
    if (useSamePath === void 0) { useSamePath = false; }
    var properFieldName = fieldToTrack;
    if (useSamePath) {
        properFieldName = resolveUseSamePath(fieldName, fieldToTrack);
    }
    var input = useField(properFieldName, {
        subscription: { value: true },
    }).input;
    return input === null || input === void 0 ? void 0 : input.value;
};
